import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/kredytyfirmowe.jpg'
import Footer from '../components/Footer'

const KredytyFirmowe = () => {

  const rodzaje = [
    {
      id: 1,
      text: "Kredyt Inwestycyjny",
      text2: "Chcesz rozwijać swoją firmę? Chcesz kupić nieruchomość, zbudować nową siedzibę, halę lub magazyn? Banki mogą skredytować wszystko co związane z Twoją działalnością. Mądrze zainwestowane pieniądze z kredytu inwestycyjnego umożliwią Ci rozwój firmy. W przypadku tego typu finansowań można uzyskać daną kwotę na zakup środka trwałego który niekoniecznie musi stanowić zabezpieczenie kredytu a to daje kolejne możliwości przedsiębiorcy. Proponowany okres finansowania do 20 lat",
    },{
      id: 2,
      text: "Kredyt Obrotowy",
      text2: "Bardzo popularna forma wspierania płynności finansowej. Jest to elastyczna forma finansowania przyznawana nawet na okres 3 lat. Kredyty obrotowe w rachunku dla firm udzielane są na podstawie przychodu – czyli obrotów generowanych przez firmę.",
    },{
      id: 3,
      text: "Kredyt Ratalny",
      text2: "Oferowane kredyty dla firm w formie gotówkowej to typowy produkt na prowadzenie bieżącej działalności gospodarczej ,rozszerzenie działalności, a także na bieżącą spłatę należności. Są wybierane przez osoby marzące o skutecznym rozwoju swojego przedsiębiorstwa, które nie mają innego źródła finansowania swoich inwestycji. Przyznanie kredytu firmowego, nierzadko w znacznej kwocie, wiąże się z wieloma formalnościami. Często jest to proces długotrwały, ponieważ bank będzie chciał dokładnie prześwietlić finansowe dokumenty firmy i sprawdzić, z jak dużym ryzykiem łączy się podjęcie danej inwestycji. Proponowany okres finansowania nawet do 10 lat.",
    },
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="KREDYTY FIRMOWE" text2=""/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
        <div className='text-center px-10 lg:px-20'>
            <div className='py-20'>
              <h2 className='font-semibold text-2xl pb-2'>Chcesz rozwijać swoją działalność i osiągnąć większe zyski?</h2>
              <p>Nie ma problemu, kredyt firmowy Ci to umożliwi. Jest wiele możliwości wsparcia, wystarczy tylko wybrać odpowiednie rozwiązanie. Spotkanie z ekspertem pozwoli wskazać jakie rozwiązanie będzie dla Ciebie najlepsze.</p>
            </div>
            <div>
              <h2 className='font-semibold text-2xl'>Rodzaje finansowania</h2>
              <div className='grid sm:grid-cols-2'>
                  {rodzaje.map((item) => (
                    <div key={item.id} className='px-10 pt-10'>
                      <h2 className='font-semibold text-xl pb-2'>{item.text}</h2>
                      <p>{item.text2}</p>
                    </div>
                  ))}
              </div>
            </div>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default KredytyFirmowe